export * from './lib/skeleton.module';

export * from './lib/skeleton-rect/skeleton-rect.component';
export * from './lib/skeleton.directive';
